// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"f72f99b6","361":"9c8b793f","767":"f51e8d34"}[chunkId] + ".chunk.js";
};